import * as companyProfileModule from '@serenita/company-profile'

// CJS/ESM normalization
const resolved = companyProfileModule?.companyProfile ?? companyProfileModule

export const companyProfile = resolved
export const COMPANY_SLUG = resolved?.slug
export const COMPANY_CLIENT_ID = import.meta.env.VITE_COMPANY_CLIENT_ID
